//Third party libraries
import CardWrapper from '@/components/UI/CardWrapper';
import { useSelector } from 'react-redux';

//Custom components
import DashboardWidget from '@/components/DashboardWidget';
import ConstructionTypeWidget from '@/components/Widgets/ConstructionTypeWidget';
import { DashboardName, Widget } from '@/components/Widgets/constants';
import DeliverableWidget from '@/components/Widgets/DeliverableWidget';
import MilestoneWidget from '@/components/Widgets/MilestoneWidget';
import NeighborhoodImpactWidget from '@/components/Widgets/NeighborhoodImpactWidget';
import ProjectBudgetSummaryWidget from '@/components/Widgets/ProjectBudgetSummaryWidget';
import ProjectLocationWidget from '@/components/Widgets/ProjectLocationWidget';
import ProjectTypeWidget from '@/components/Widgets/ProjectTypeWidget';
import TaskWidget from '@/components/Widgets/TaskWidget';

//Services
import { useDashboardWidgetsList } from '@/hooks/ReactQueryHooks/useDashboardQuery';
import { authSelector } from '@/store';

export default function MyDashboard() {
  const { data: currentUserData } = useSelector(authSelector);
  const { isWidgetUsed } = useDashboardWidgetsList({
    dashboard: DashboardName.USER_DASHBOARD,
  });

  return (
    <div className='max-w-screen-3xl mx-auto'>
      <h2 className='mb-0'>Welcome Back {currentUserData.name.split(' ')[0]},</h2>
      <div className='mb-4 -mt-6'>
        <DashboardWidget dashboard={DashboardName.USER_DASHBOARD} />
      </div>
      <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 w-full'>
        {isWidgetUsed?.[Widget.TASKS_COUNT] && (
          <div className='min-w-0 w-full'>
            <CardWrapper customClass='h-full'>
              <TaskWidget dashboard={DashboardName.USER_DASHBOARD} />
            </CardWrapper>
          </div>
        )}

        {isWidgetUsed?.[Widget.DELIVERABLES_COUNT] && (
          <div className='min-w-0 w-full'>
            <CardWrapper customClass='h-full'>
              <DeliverableWidget dashboard={DashboardName.USER_DASHBOARD} />
            </CardWrapper>
          </div>
        )}

        {isWidgetUsed?.[Widget.MILESTONES_COUNT] && (
          <div className='min-w-0 w-full'>
            <CardWrapper customClass='h-full'>
              <MilestoneWidget dashboard={DashboardName.USER_DASHBOARD} />
            </CardWrapper>
          </div>
        )}
      </div>
      {isWidgetUsed?.[Widget.PROJECT_LOCATION] && (
        <div className='mt-12'>
          <ProjectLocationWidget dashboard={DashboardName.USER_DASHBOARD} />
        </div>
      )}
      <section className='flex flex-col gap-8 mt-8 w-full min-w-0'>
        {isWidgetUsed?.[Widget.PROJECTS_BY_CONSTRUCTION_TYPE] && (
          <div className='min-w-0 w-full'>
            <ConstructionTypeWidget dashboard={DashboardName.USER_DASHBOARD} />
          </div>
        )}

        {isWidgetUsed?.[Widget.PROJECTS_BY_PROJECT_TYPE] && (
          <div className='min-w-0 w-full'>
            <ProjectTypeWidget dashboard={DashboardName.USER_DASHBOARD} />
          </div>
        )}

        {isWidgetUsed?.[Widget.PROJECTS_BY_NEIGHBORHOOD] && (
          <div className='min-w-0 w-full'>
            <NeighborhoodImpactWidget dashboard={DashboardName.USER_DASHBOARD} />
          </div>
        )}

        {isWidgetUsed?.[Widget.PROJECT_BUDGET_SUMMARY] && (
          <div className='min-w-0 w-full'>
            <ProjectBudgetSummaryWidget dashboard={DashboardName.USER_DASHBOARD} />
          </div>
        )}
      </section>
    </div>
  );
}
